/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Usage_PrdInputs */

const en_settings_usage_prd = /** @type {(inputs: Settings_Usage_PrdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans`)
};

const id_settings_usage_prd = /** @type {(inputs: Settings_Usage_PrdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana`)
};

/**
* | output |
* | --- |
* | "Plans" |
*
* @param {Settings_Usage_PrdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_usage_prd = /** @type {((inputs?: Settings_Usage_PrdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Usage_PrdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_usage_prd(inputs)
	return en_settings_usage_prd(inputs)
});